<owl-carousel-o [options]="customOptions">
    <ng-container *ngFor="let slide of slides">
        <ng-template class="slide" carouselSlide>
            <img class="rounded-lg" [src]="slide" onerror="this.onerror=null;this.src='assets/img/on_error_slide.png'">
        </ng-template>
    </ng-container>
</owl-carousel-o>
